<template>
    <div class="language-switcher">
        <a class="link language-switcher-link" :class="[ $i18n.locale === 'cn' ? 'active' : '' ]" href="javascript:void(0)" @click.prevent="changeLocale('cn')">{{ $t('common.locale.cn') }}</a>
        <a class="link language-switcher-link" :class="[ $i18n.locale === 'en' ? 'active' : '' ]" href="javascript:void(0)" @click.prevent="changeLocale('en')">{{ $t('common.locale.en') }}</a>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { localise } from '@/router'

  export default {
    computed: {
      ...mapGetters([
        'isContent'
      ])
    },
    methods: {
      changeLocale (locale) {
        if (locale === this.$i18n.locale) {
          return
        }

        if (!this.isContent) {
          return this.setLocale(locale)
        }

        window.location = localise(this.$router.currentRoute, locale)
      },
      ...mapActions([
        'setLocale'
      ])
    }
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .landing-header {
        .language-switcher {
            display: flex;
            margin-right: 2rem;

            @include media-breakpoint-up(xl) {
                margin-right: 3rem;
            }

            &-link {
                margin-left: 1rem;

                &:first-child {
                    margin-left: 0;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// LanguageSwitcher.vue?2ab7638f